module.exports = __webpack_public_path__ + "components/rewards/no-ads/static/logo-1d92822112fef07e641000bfd1914951.jpg";